import TaxPayer from "app/pages/taxPayers/models/TaxPayer";
import { withStatus, withTimesTamps } from "app/pages/receipts/models/commons";
import { formatCurrency } from "cofa/utils/functions/text";

class MarketMonthlyDepositTaxReceipt {
  ref;
  code;
  secret;
  amount;
  paymentDate;
  billRef;
  period;
  agentId;
  agentName;
  agentDepositDate;
  agentDepositRef;
  cashierId;
  cashierName;
  cashierDepositDate;
  canceled;
  canceledAt;
  canceledBy;
  cancelReason;
  canceledByName;
  longitude;
  latitude;
  marketName;
  marketRef;
  taxPayerName;
  taxPayerRef;
  taxPayerPhone;
  taxPayer;
  paymentMode;
  searchSlug;

  constructor(receipt) {
    Object.assign(this, receipt);
  }

  static fromJson(receipt) {
    return new MarketMonthlyDepositTaxReceipt({
      ref: receipt["ref"],

      code: receipt["code"],
      secret: receipt["secret"],

      amount: receipt["amount"],
      paymentDate: receipt["payment_date"],
      period: receipt["period"],
      billRef: receipt["bill_ref"],

      agentId: receipt["agent_id"],
      agentName: receipt["agent_name"],
      agentDepositDate: receipt["agent_deposit_date"],
      agentDepositRef: receipt["agent_deposit_ref"],

      deposed: !!receipt["agent_deposit_date"],
      collected: !!receipt["agent_deposit_date"],

      cashierId: receipt["cashier_id"],
      cashierName: receipt["cashier_name"],
      cashierDepositDate: receipt["cashier_deposit_date"],

      canceled: !!receipt["canceled_at"],
      notCanceled: !receipt["canceled_at"],
      canceledAt: receipt["canceled_at"],
      canceledBy: receipt["canceled_by_id"],
      canceledByName: receipt["canceled_by_name"],
      cancelReason: receipt["cancel_reason"],

      longitude: receipt["longitude"],
      latitude: receipt["latitude"],

      marketName: receipt["market_name"],
      marketRef: receipt["market_ref"],

      taxPayerName: receipt["tax_payer_name"],
      taxPayerRef: receipt["tax_payer_ref"],
      taxPayerPhone: receipt["tax_payer_phone"],

      taxPayer: receipt["tax_payer"] && TaxPayer.fromJson(receipt["tax_payer"]),

      ...withTimesTamps(receipt),
      ...withStatus(receipt),

      createdAt: receipt["created_at"],
      updatedAt: receipt["updated_at"],
      lastUpdate: receipt["updated_at"] ?? receipt["created_at"],
      lastUpdateFormatted: new Date(
        (receipt["updated_at"] ?? receipt["created_at"])?.substring(0, 10)
      )?.toLocaleString("fr-FR", {
        timeZone: "UTC",
        dateStyle: "long",
      }),
    });
  }

  getLabelFr(modes) {
    return (
      modes.find((mode) => mode.code === this.paymentMode)?.label ??
      this.paymentMode
    );
  }

  getSearchSlug(additionalValues = []) {
    return [
      ...additionalValues,
      this.ref,
      this.code,
      this.secret,
      this.taxPayer?.ref,
      this.taxPayer?.address,
      this.taxPayer?.phone,
      this.taxPayer?.nif,
      this.taxPayer?.address,
      this.taxPayer?.firstName,
      this.taxPayer?.lastName,
      this.amount,
      formatCurrency(this.amount),
      this.paymentMode,
      this.agentId,
      this.agentName,
      this.agentDepositRef,
      this.cashierId,
      this.cashierName,
      this.marketName,
      this.marketRef,
      this.taxPayerName,
      this.taxPayerRef,
      this.taxPayerPhone,
      this.canceledBy,
      this.canceledByName,
      this.cancelReason,
    ].join("");
  }

  populateWithData({ paymentModes = [] }) {
    //Translate Payment mode to French.
    this.paymentModeFr = this.getLabelFr(paymentModes);

    //Generate search slug that easier search.
    this.searchSlug = this.getSearchSlug([this.paymentModeFr]);

    //Use this method in fluent mode.
    return this;
  }

  asCanceled() {
    this.amount = -1 * this.amount;
    this.canceled = true;

    return this;
  }

  removeCanceledState() {
    this.canceled = false;

    this.canceledAt = null;
    this.canceledBy = null;
    this.canceledByName = null;
    this.cancelReason = null;

    return this;
  }
}

export default MarketMonthlyDepositTaxReceipt;
